module.exports = __webpack_public_path__ + "img/construction-video.6c5514dc.svg";